import type { TFunction } from 'i18next';
import { object, string } from 'yup';

import {
  makeEmail,
  makeName,
} from 'src/modules/onboarding/validations/validations';
import { makePassword, makePhoneNumber } from 'src/shared/validationSchemas';

// TODO: move generic validations to shared namespace

export const makeLeadValidationSchema = ({
  t,
  showFullName,
  showEmail,
  showPostalCode,
  showPhoneNumber,
}: {
  t: TFunction;
  showFullName: boolean;
  showEmail: boolean;
  showPostalCode: boolean;
  showPhoneNumber: boolean;
}) =>
  object().shape({
    fullName: showFullName ? makeName(t) : string().notRequired(),
    phoneNumber: showPhoneNumber
      ? makePhoneNumber(
          t,
          'onboarding.phoneNumberIsRequired',
          'onboarding.pleaseProvideAValidPhoneNumber',
        )
      : string().notRequired(),
    email: showEmail ? makeEmail(t) : string().notRequired(),
    postalCode: showPostalCode
      ? string().required(t('onboarding.postalCodeIsRequired'))
      : string().notRequired(),
  });

export const makeCreateAccountValidationSchema = (t: TFunction) =>
  object().shape({
    password: makePassword(t),
  });
